import { useRef } from "react";

/** This is useful to preserve the last rendered modal content until the modal is completely closed. */
export const useLastNonNullRender = (f: () => React.ReactNode) => {
  const ref = useRef<React.ReactNode>(null);
  ref.current = f() ?? ref.current;
  return ref.current;
};
